<template>
  <div class="text-wrap">
    <div class="line left"></div>
    <span class="text">{{ title }}</span>
    <div class="line reverse"></div>
  </div>
</template>
<script>
export default {
  name: 'SplitLine',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="scss" scoped>
.text-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  display: flex;
  margin: 0 auto;
  width: 100%;
  .line {
    height: 1px;
    flex: 1;
    background: linear-gradient(to right, #f5f5f7 0%, #dddddd 100%);
    &.left {
      top: 50%;
      left: 0;
    }
    &.reverse {
      top: 50%;
      right: 0;
      transform: scaleX(-1);
    }
  }
  .text {
    padding: 0px 20px;
    font-family: 'Aspira Light';
    font-size: 12px;
    position: relative;
    color: #666666;
    text-align: left;
  }
}
</style>
